module.exports = "/fonts/boxicons.eot?afbad0fa2cbbb785e034ae3e3bb328ff";